import { render, staticRenderFns } from "./StatisticsOld.vue?vue&type=template&id=3c6e694e&scoped=true"
import script from "./StatisticsOld.vue?vue&type=script&lang=js"
export * from "./StatisticsOld.vue?vue&type=script&lang=js"
import style0 from "../assets/css/statistics.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./StatisticsOld.vue?vue&type=style&index=1&id=3c6e694e&prod&lang=scss"
import style2 from "./StatisticsOld.vue?vue&type=style&index=2&id=3c6e694e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6e694e",
  null
  
)

export default component.exports